import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface LegalPageProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export default function LegalPage({ title, subtitle, children }: LegalPageProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <section className="bg-background-100 pt-16 md:pt-24 pb-12 md:pb-16">
        <div className="px-4 md:px-10 max-w-4xl">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.18em] text-accent-600 hover:text-accent-700 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Zurück zur Startseite
          </Link>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl leading-tight text-foreground-950">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl">
              {subtitle}
            </p>
          )}
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="px-4 md:px-10 max-w-4xl">
          <div className="space-y-8 text-sm md:text-base leading-relaxed text-foreground-700">
            {children}
          </div>
        </div>
      </section>
    </div>
  );
}